import script from "./setup-fee-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./setup-fee-modal.vue?vue&type=script&setup=true&lang=ts"

import "./setup-fee-modal.vue?vue&type=style&index=0&id=8279e54a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8279e54a"]])

export default __exports__